import { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import { attemptToJoinExam, finishExam, getSchoolName, leaveExam } from "../../assets/api/userActions";
import CountDown from "../../components/countDown/countDown";


// import HomeworkQuestion from '../../components/homeworkQuetion';

import UploadButtons from '../../components/uploadButtons';


import { ReactComponent as Exit } from '../../assets/icons/exit.svg';
import { ReactComponent as Refresh } from '../../assets/icons/RightSquare.svg';

import classes from '../../App.module.scss';
import QuizQuestionFileViewer from '../../components/quizQuestionFileViewer/QuizQuestionFileViewer';
import { buildPdfStreamUrl } from '../../assets/utils/pdfViewerUrl';
import { getQuizQuestionDownloadLabel } from '../../assets/utils/quizQuestionFile';
import { checkMatchQuestionURL, safeParseLocalStorageJson } from "../../assets/utils/utils";
import Loading from "../../components/loading/loading";
import { useLeaveExamOnTabClose } from "../../hooks/useLeaveExamOnTabClose";
import { showExamExitConfirmSwal } from '../../assets/utils/examExitConfirmSwal';

function DescriptivePdfExam() {


    const navigate = useNavigate();
    const params = useParams();

    const [activeBtn, setActiveBtn] = useState(null);
    const [examData, setExamData] = useState();
    const [userAnswered, setUserAnswered] = useState()
    const [examDataAttempt, setExamDataAttempt] = useState();
    const [isLoading, setIsLoading] = useState(true);
    const [timeLeft, setTimeLeft] = useState(0);
    const [totalTime, setTotalTime] = useState(0);
    const [schoolName, setSchoolName] = useState("")
    const [answered, setAnswered] = useState()
    const [unAnswered, setUnAnswered] = useState()
    const fetchInProgress = useRef(false);
    const storedUser = safeParseLocalStorageJson("userToken");

    const isInThePast = useCallback((date) => {
        const today = new Date();
        return date < today;
    }, []);

    const toLoginPage = useCallback(() => {
        localStorage.removeItem("userToken");
        navigate(`/quiz/join/${params.quiz}`);
    }, [navigate, params.quiz]);

    const fetchData = useCallback(async () => {
        const data = await attemptToJoinExam(params.quiz);
        if (data?.status === "attempt-finished") {
            navigate('/quiz/finish');
            setIsLoading(false);
            return;
        }
        setExamData(data);
        if (data?.status !== "joined") {
            let a = data?.message;
            a = a.split("{").join("");
            a = a.split("}").join("");
            if (a.includes("date")) {
                a = a.replace("date", data?.date);
            }
            if (a.includes("time")) {
                a = a.replace("time", data?.time);
            }
            setTimeout(() => {
                navigate("/quiz/join/" + params.quiz);
            }, "2000");
        }
        data.attempt.answers && setUserAnswered(checkMatchQuestionURL(data.quiz, data.attempt));
        setExamDataAttempt(data.attempt);
        setTimeLeft(data.attempt.timer);
        setTotalTime(data.attempt.total_time);
        setIsLoading(false);
        setAnswered(data.attempt.answered_questions);
        setUnAnswered(data.attempt.unanswered_questions);
        return data.quiz.title;
    }, [params.quiz, navigate]);

    function answerAttemptResHandler(data) {
        // console.log(data);
        setAnswered(data.answered_questions)
        setUnAnswered(data.unanswered_questions)
    }


    const fetchSchoolName = useCallback(async () => {
        await getSchoolName(params.quiz).then((res) => setSchoolName(res.schoolName));
    }, [params.quiz]);
    const answerResHandler = (data) => {
        // console.log(data);
        setAnswered(data.answered_questions);
        setUnAnswered(data.unanswered_questions)
    }

    const onFinishHandler = async (e) => {
        const res = await finishExam(e);
        if (res?.status === 'success-finish') {
            navigate('/quiz/finish');
            return;
        }
        throw new Error(res?.message || 'امکان اتمام آزمون نیست');
    };

    const onLeaveHandler = async (e) => {
        const res = await leaveExam(e);
        if (res?.status === 'success-leave') {
            navigate('/quiz/join/' + params.quiz);
            return;
        }
        throw new Error(res?.message || 'امکان ترک آزمون نیست');
    };

    const showExitConfirm = (leave) => {
        const isLeaveExam = !!leave;
        showExamExitConfirmSwal({
            isLeaveExam,
            unansweredCount: isLeaveExam ? 0 : unAnswered,
            onConfirm: async () => {
                if (isLeaveExam) await onLeaveHandler(examDataAttempt.id);
                else await onFinishHandler(examDataAttempt.id);
            },
        });
    };
    useLeaveExamOnTabClose(examData?.quiz?.leave, examDataAttempt?.id);

    useEffect(() => {
        document.title = "شروع آزمون";
        const LSdata = safeParseLocalStorageJson("userToken");
        if (!LSdata) {
            navigate(`/quiz/join/${params.quiz}`);
            return;
        }
        if (LSdata && isInThePast(LSdata.expireDate)) {
            toLoginPage();
            return;
        }
        if (fetchInProgress.current) return;
        fetchInProgress.current = true;
        const examTitlePromise = fetchData();
        fetchSchoolName();
        examTitlePromise.finally(() => {
            fetchInProgress.current = false;
        });
        examTitlePromise.then((res) => res && (document.title = `آزمون ${res}`));
    }, [params.quiz, navigate, fetchData, fetchSchoolName, toLoginPage, isInThePast]);



    const activeBtnHandler = (index) => {
        setActiveBtn(index);
    }
    const nullingActiveBtnHandler = () => {
        setActiveBtn(null);
    }

    return (
        <div className={`${classes.appContainer} ${classes.examAppContainer}`}>
            {
                !isLoading ?

                    examData && <div className={classes.container}>
                        <header className={classes.timeRemainedContainer} style={{ display: 'grid' }}>
                            <div className={classes.headerBox}>
                                <div className={classes.buttonContainer}>
                                    <p className={classes.finishExamBtn} onClick={() => showExitConfirm(false)}>اتمام آزمون</p>
                                    {examData.quiz.leave && <p className={classes.leaveExamBtn} onClick={() => showExitConfirm(true)}>ترک آزمون</p>}
                                </div>
                                {timeLeft !== "unlimited" ? <CountDown totalTime={totalTime} timeRemained={timeLeft} attemptID={examDataAttempt?.id} /> : <p className={classes.unlimited_text}>زمان باقیمانده : نامحدود</p>}
                                {/* <div className='time-remained'>4:20:00</div> */}
                            </div>
                            <div className={classes.informationBar}>
                                <div className={classes.examDetails}>
                                    <div className={classes.examDetailsTitle}>
                                        <h1>{examData.quiz.title}</h1>
                                        <p>{`(${schoolName})`}</p>
                                    </div>
                                    <div id={classes.returnBtn}>
                                        <p>بازگشت به سایت</p>
                                        <div className={classes.exitIcon}>
                                            <Exit fill='#fff' width="15px" height='15px' />
                                        </div>
                                    </div>
                                </div>
                                <div className={classes.personalDetails}>
                                    <ul>
                                        <li>{`نام کاربر : ${storedUser?.name ?? ""}`}</li>
                                        <li>{`مدت آزمون : ${examData?.quiz?.duration ? examData?.quiz?.duration + " دقیقه " : "نامحدود"}`}</li>
                                        <li>{`نوع آزمون : ${examData.quiz.type === "test" ? "تستی" : "تشریحی"}`}</li>
                                        <li>{`نمره کل : ${examData.quiz.total_score}`}</li>
                                        <li>{`تعداد سوالات : ${examData.quiz.number_of_question}`}</li>
                                    </ul>
                                </div>
                            </div>
                        </header>

                        <main className={classes.mainContainer}>
                            <div className={classes.answerSheetContainer}>
                                <div className={classes.answerSheetHeader}>
                                    <h3>پاسخنامه</h3>
                                    <div className={classes.answerDatasheet}>
                                        <p className={classes.answerDatasheet_answer}>{`پاسخ داده شده : ${answered === null ? 0 : answered}`}</p>
                                        <p className={classes.answerDatasheet_notAnswer}>{`پاسخ داده نشده : ${unAnswered === null ? 0 : unAnswered}`}</p>
                                    </div>
                                </div>
                                <div className={classes.uploadAnswersSheet}>
                                    <ol>
                                        {
                                            examData.quiz?.questions?.map((data) => (
                                                <UploadButtons
                                                    key={data.id}
                                                    index={data.id} quNo={data.question_number} options={data.options} score={data.score}
                                                    activeBtn={activeBtn} attemptID={examDataAttempt.id}
                                                    activeBtnHandler={activeBtnHandler} answerAttemptRes={answerAttemptResHandler}
                                                    userAnswered={userAnswered} answerResHandler={answerResHandler}
                                                    nullingActiveBtnHandler={nullingActiveBtnHandler}
                                                    onAnswerUpdated={fetchData}
                                                />
                                            ))
                                        }

                                    </ol>
                                </div>
                            </div>
                            {/* DISPLAY QUESTION / QUESTION SECTION  */}
                            <section className={classes.questionSection}>
                                <div className={classes.questionSection_header}>
                                    <h2>سوالات آزمون</h2>

                                    {/* محفظه نگهدارنده دکمه‌ها */}
                                    <div style={{ display: 'flex', gap: '10px' }}>

                                        {/* دکمه دانلود PDF */}
                                        <div
                                            className={classes.reloadBtn}
                                            onClick={() => window.open(buildPdfStreamUrl(examData?.quiz?.question_pdf), '_blank')}
                                            style={{ cursor: 'pointer', backgroundColor: '#4CAF50' }} // می‌توانید استایل دلخواه خود را در CSS اعمال کنید
                                        >
                                            <p>
                                                {getQuizQuestionDownloadLabel(
                                                    examData?.quiz?.question_file_extension || examData?.quiz?.question_pdf,
                                                )}
                                            </p>
                                            <div id={classes.refreshIcon}>
                                                {/* می‌توانید یک آیکون دانلود اینجا قرار دهید */}
                                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                                                    <polyline points="7 10 12 15 17 10"></polyline>
                                                    <line x1="12" y1="15" x2="12" y2="3"></line>
                                                </svg>
                                            </div>
                                        </div>

                                        {/* دکمه بارگذاری مجدد (موجود در کد شما) */}
                                        <div className={classes.reloadBtn} onClick={() => window.location.reload()}>
                                            <p>بارگذاری مجدد</p>
                                            <div id={classes.refreshIcon}>
                                                <Refresh />
                                            </div>
                                        </div>

                                    </div>
                                </div>

                                <div className={classes.questionContainer}>
                                    <QuizQuestionFileViewer
                                        fileUrl={examData?.quiz?.question_pdf}
                                        downloadUrl={examData?.quiz?.question_pdf}
                                        fileExtension={examData?.quiz?.question_file_extension}
                                    />
                                </div>
                            </section>

                        </main>

                    </div> : <>
                        <Loading />
                    </>}
        </div>
    );
}

export default DescriptivePdfExam;
